import { Node, NodeWithParent } from './types';
import { NODE_ITEM_HEIGHT } from './StyledCheckboxTreeElements';

export const transverseTree = (nodes: NodeWithParent[], uids: string[], action: (node: Node, uids: string[]) => void) =>
  nodes.forEach((item) => {
    action(item, uids);

    // original_children comes from Searchable CheckboxTreeSelect component
    if (item?.original_children && item?.original_children.length > 0) {
      transverseTree(item.original_children, uids, action);
    } else if (item?.children && item?.children.length > 0) {
      transverseTree(item.children, uids, action);
    }
  });

export const isRootNode = (value: string, rootNodes: Node[]): boolean =>
  !!rootNodes.find((node) => node.value === value);

export const anyChildrenChecked = (nodes: Node[], checked: string[]): boolean =>
  !!nodes.find((node) => {
    if (findNode(node, checked).match) return true;
    if (node?.children?.length) return anyChildrenChecked(node.children || [], checked);
    return false;
  });

export const isLeaf = (node: Node): boolean => !!node.children && node.children.length > 0;

export const isExpanded = (node: Node, keepExpanded: boolean | undefined, expanded: string[]): boolean =>
  isLeaf(node) && ((keepExpanded ?? false) || findNode(node, expanded).match);

export const isMatch = (node: Node): boolean => node.match === true || typeof node.match === 'undefined';

export function findNode(
  node: Node,
  elements: string[]
): {
  index: number;
  match: boolean;
} {
  const index = elements.indexOf(node.value);
  return {
    index,
    match: elements.indexOf(node.value) !== -1
  };
}

export function addToArray(node: Node, elements: string[] = []): void {
  if (!findNode(node, elements).match) {
    elements.push(node.value);
  }
}

export function removeFromArrayByIndex(index: number, elements: string[] = []): void {
  elements.splice(index, 1);
}

export function removeFromArrayByNode(node: Node, elements: string[] = []): void {
  const item = findNode(node, elements);
  if (item.match) {
    removeFromArrayByIndex(item.index, elements);
  }
}

export function getVisibleItemsCount(nodes: Node[], keepExpanded: boolean | undefined, expanded: string[]): number {
  return nodes.reduce((result, node) => result + getVisibleItemCount(node, keepExpanded, expanded), 0);
}

function getVisibleItemCount(item: Node, keepExpanded: boolean | undefined, expanded: string[]): number {
  let count = 1;

  if (isExpanded(item, keepExpanded, expanded) && (typeof item.match === 'undefined' || item.match)) {
    count +=
      item.children
        ?.map((child) => getVisibleItemCount(child, keepExpanded, expanded))
        .reduce((total, count) => total + count, 0) ?? 0;
  }

  return count;
}

export function getCheckBoxTreeTotalHeight(
  nodes: Node[],
  keepExpanded: boolean | undefined,
  expanded: string[]
): number {
  return getVisibleItemsCount(nodes, keepExpanded, expanded) * NODE_ITEM_HEIGHT;
}
